import APIController from "./APIController";
import SyncHelper from '../Helper/SyncHelper';
import {useWebSocket} from "../Context/WebSocketContext";

const User = () =>{
    //Requesthelper
    const {basicRequest} = APIController()
    const { pingRequest } = SyncHelper()
    const {isOnline} = useWebSocket()

    const login = async(userDTO) =>{
        const data = await basicRequest(`/user/login`, "POST", userDTO, "no-cors", false)
        if (data.ok){
            await saveToken(data)
        }
        return data
    }

    const register = async(userRegisterDTO) =>{
        const data = await basicRequest(`/user/register`, "POST", userRegisterDTO, "no-cors", false)
        return data
    }

    const getUser = async() => {
        if (await pingRequest() === false) return localStorage.getItem("user");;
        const data = await basicRequest(`/user`)
        if (data.ok){
            const user = await data.json();
            localStorage.setItem("user", JSON.stringify(user)); 
        }
        return data
    }

    const approve = async(passcode) =>{
        const data = await basicRequest(`/user/approve/${passcode}`, "PUT")
        return data
    }

    const requestMail = async(userEmailDTO) =>{
        const data = await basicRequest(`/user/send_password_reset`, "PUT", userEmailDTO, "no-cors", false)
        return data
    }

    const resetPassword = async(userPasswordDTO, token) =>{
        const data = await basicRequest(`/user/set_new_password/${token}`, "PUT", userPasswordDTO, "no-cors", false)
        return data
    }

    //Login handler (Save token)
    const saveToken = async(response)=>{
        const token = response.headers.get("Authorization"); 
        if (token && token.startsWith("Bearer ")) {
            localStorage.setItem("token", token);
            await getUser()
        }
    }

    return{
        login,
        getUser,
        register,
        approve,
        requestMail,
        resetPassword
    }
}

export default User